import { IconProps } from "../../types/utils";

const DensityIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 18}
    height={dimension || 14}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.08762 0.485352C1.45131 0.485352 0.935547 1.00111 0.935547 1.63742C0.935547 2.27359 1.45131 2.78949 2.08762 2.78949H15.9116C16.5479 2.78949 17.0637 2.27373 17.0637 1.63742C17.0637 1.00111 16.5479 0.485352 15.9116 0.485352H2.08762ZM2.08762 5.86135C1.45131 5.86135 0.935547 6.37711 0.935547 7.01342C0.935547 7.64959 1.45131 8.16549 2.08762 8.16549H15.9116C16.5479 8.16549 17.0637 7.64973 17.0637 7.01342C17.0637 6.37711 16.5479 5.86135 15.9116 5.86135H2.08762ZM2.08762 11.2374C1.45131 11.2374 0.935547 11.7531 0.935547 12.3894C0.935547 13.0256 1.45131 13.5415 2.08762 13.5415H15.9116C16.5479 13.5415 17.0637 13.0257 17.0637 12.3894C17.0637 11.7531 16.5479 11.2374 15.9116 11.2374H2.08762Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default DensityIcon;
